import React, { Component } from 'react';
import moment from 'moment-timezone';
import * as Sentry from '@sentry/browser';
import localStorage from 'local-storage';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import DriverTracker from '../../components/DriverTracker';

import {
  fetchCurrentOrder,
  fetchDriverOnTheWay,
  fetchOrderStatusHistory,
  fetchDriverRunOrder,
  resetCurrentOrder,
  getAllShifts,
  getHalfHalf,
  getStoreInfo,
} from './actions';
import '../../assets/css/bootstrap.min.css';
import '../../assets/css/style.css';
import '../../assets/css/icon.css';
import '../../assets/css/responsive.css';
import { ReactComponent as Delivery } from '../../assets/images/delivery.svg';
import deliveryWhite from '../../assets/images/delivery-white.svg';
import classNames from 'classnames';
import template from './template';
import { selectStoreConfig } from '../Layout/selectors';
import { getPlatformAndCardCharges } from 'helpers/getPlatformAndCardCharges';
import getViewOrderData from './getViewOrderData';
import DineInOrderTraking from 'components/DineInOrderTraking';
import {
  MENU_ORDER_FROM,
  MENU_ORDER_STATUS,
  MENU_ORDER_TYPE,
  ORDER_STAGE_TYPES,
} from 'helpers/enums';
import { BackButtonCWUI } from '@next-order/next-order-components';
import getImage from 'helpers/getImage';
import { fetchOrder } from 'containers/Home/actions';

const idealOrderObj = {
  address: '',
  addressLocation: {},
  orderStatus: MENU_ORDER_STATUS.unconfirmed,
  orderFrom: MENU_ORDER_FROM.web,
  orderType: MENU_ORDER_TYPE.pickup,
  specials: [],
  menuItems: [],
  stage: ORDER_STAGE_TYPES.NONE,
  totalCost: 0,
  payableAmount: 0,
  isAllowToConfirm: false,
};

class OrderTracker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewOrderMode: false,
    };
  }

  componentDidCatch(error, errorInfo) {
    Sentry.withScope((scope) => {
      Object.keys(errorInfo).forEach((key) => {
        scope.setExtra(key, errorInfo[key]);
      });
      Sentry.captureException(error);
    });
  }

  componentDidMount() {
    const { storeConfig } = this.props;

    let key =
      this.props.location && this.props.location.pathname
        ? this.props.location.pathname.split('/')[2]
        : '';
    let orderType =
      this.props.location && this.props.location.pathname
        ? this.props.location.pathname.split('/')[3]
        : '';
    const searchParams = new URLSearchParams(this.props.location.search);
    const redirectFrom = searchParams.get('redirect-from');
    if (redirectFrom === 'adyen') {
      this.props.history.replace({
        pathname: this.props.location.pathname,
        search: '',
      });
      this.props.fetchOrderHandler(key);
    }

    this.props.fetchCurrentOrderHandler(key, orderType);
    this.props.fetchDriverRunOrderHandler(key, storeConfig.storeId);
    this.props.fetchOrderStatusHistoryHandler(
      key,
      orderType,
      storeConfig.storeId
    );
    this.props.getStoreInfoHandler(storeConfig.storeId);
    this.props.getHalfHalfHandler(storeConfig.storeId);
    this.props.getAllShiftsHandler(storeConfig.storeId);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.orderTracker.orderObj &&
      this.props.orderTracker.orderObj.driverId &&
      (this.props.orderTracker.orderObj.orderStatus ===
        MENU_ORDER_STATUS.out_for_delivery ||
        this.props.orderTracker.orderObj.orderStatus ===
          MENU_ORDER_STATUS.on_the_way ||
        this.props.orderTracker.orderObj.orderStatus ===
          MENU_ORDER_STATUS.arriving ||
        this.props.orderTracker.orderObj.orderStatus ===
          MENU_ORDER_STATUS.arrived)
    ) {
      if (!prevProps.orderTracker.driver) {
        this.props.fetchDriverOnTheWayHandler(
          this.props.orderTracker.orderObj.driverId,
          prevProps.storeConfig.storeId
        );
      }
      if (!prevProps.orderTracker.driverRunOrder) {
        this.props.fetchDriverRunOrderHandler(
          this.props.orderTracker.orderObj._id,
          prevProps.storeConfig.storeId
        );
      }
    }
  }

  getItemGroupingsForReviewOrder = (currentOrder) => {
    let selectedOrder = JSON.parse(JSON.stringify(currentOrder));
    let items = [];
    if (selectedOrder && selectedOrder.menuItems) {
      selectedOrder.menuItems.map((item) => {
        if (item.isHalf) {
          let betterHalfs = currentOrder.menuItems.filter((obj) => {
            return obj.halfIndex === item.halfIndex && obj._id !== item._id;
          });
          let xBetterHalf = items.filter((obj) => {
            return obj._idHalf === item._id;
          });
          if (
            betterHalfs &&
            betterHalfs?.length > 0 &&
            xBetterHalf?.length === 0
          ) {
            item.urlHalf = getImage(
              betterHalfs[0].mediaPath || betterHalfs[0].urlS3
            );
            item._idHalf = betterHalfs[0]._id;
            item.nameHalf = betterHalfs[0].name;
            item.itemTypeHalf = betterHalfs[0].itemType;
            item.baseModifierIdHalf = betterHalfs[0].baseModifierId;
            item.selectedSizesHalf = betterHalfs[0].selectedSizes;
            item.selectedModifiersHalf = betterHalfs[0].selectedModifiers;
            item.removedIngredientsHalf = betterHalfs[0].removedIngredients;
            item.selectedIngredientsHalf = betterHalfs[0].selectedIngredients;
            item.selectedExtraIngredientsHalf =
              betterHalfs[0].selectedExtraIngredients;
            items.push(item);
          }
        } else {
          items.push(item);
        }
        return item;
      });
    }
    return items;
  };

  getOrderStatusDisplayText = () => {
    const { orderTracker } = this.props;
    const { orderObj } = orderTracker;

    if (orderObj) {
      if (orderObj?.orderStatus === MENU_ORDER_STATUS.unconfirmed) {
        let allShifts = [];
        if (orderTracker?.allShifts) {
          allShifts = orderTracker?.allShifts;
          let filteredShift = allShifts.filter((obj) => {
            return obj.isCurrent === true || obj.isDeliveryOpen === true;
          });
          if (filteredShift?.length <= 0)
            return 'Store is currently closed. Order will be confirmed once it opens.';
          else return 'Order is waiting for confirmation.';
        } else {
          return 'Order is waiting for confirmation.';
        }
      } else if (
        orderObj?.orderStatus === MENU_ORDER_STATUS.placed ||
        orderObj?.orderStatus === MENU_ORDER_STATUS.in_kitchen
      ) {
        // Show table number if it is "Dine-in"
        const table =
          orderObj?.orderType === MENU_ORDER_TYPE.dinein &&
          orderObj?.tableNumber
            ? ` for Table ${orderObj?.tableNumber}`
            : '';
        return `Your order is confirmed${table}!`;
      } else if (orderObj?.orderStatus === MENU_ORDER_STATUS.out_for_delivery) {
        return 'Your order is out for the delivery!';
      } else if (orderObj?.orderStatus === MENU_ORDER_STATUS.on_the_way) {
        return 'Your order is on the way!';
      } else if (orderObj?.orderStatus === MENU_ORDER_STATUS.arrived) {
        return 'Your order has arrived!';
      } else if (orderObj?.orderStatus === MENU_ORDER_STATUS.arriving) {
        return 'Your order is arriving!';
      } else if (orderObj?.orderStatus === MENU_ORDER_STATUS.delivered) {
        return 'Your order is delivered!';
      } else if (orderObj?.orderStatus === MENU_ORDER_STATUS.cancelled) {
        return 'We regret to inform you that we are unable to process your order at the moment.';
      }
    }
  };

  getOrderTimeDisplayText = () => {
    if (this.props.orderTracker.orderObj) {
      if (
        this.props.orderTracker.orderObj.orderStatus ===
        MENU_ORDER_STATUS.unconfirmed
      ) {
        return `${moment(
          this.props.orderTracker.orderObj.deliveryDate,
          `YYYY-MM-DD HH:mm`
        ).format('Do MMM, hh:mm A')}`;
      } else if (
        this.props.orderTracker.orderObj.orderStatus ===
          MENU_ORDER_STATUS.placed ||
        this.props.orderTracker.orderObj.orderStatus ===
          MENU_ORDER_STATUS.in_kitchen
      ) {
        return `${moment(
          this.props.orderTracker.orderObj.deliveryDate,
          `YYYY-MM-DD HH:mm`
        ).format('Do MMM, hh:mm A')}`;
      } else if (
        this.props.orderTracker.orderObj.orderStatus ===
        MENU_ORDER_STATUS.out_for_delivery
      ) {
        return `${moment(
          this.props.orderTracker.orderObj.deliveryDate,
          `YYYY-MM-DD HH:mm`
        ).format('Do MMM, hh:mm A')}`;
      } else if (
        (this.props.orderTracker.orderObj.orderStatus ===
          MENU_ORDER_STATUS.on_the_way ||
          this.props.orderTracker.orderObj.orderStatus ===
            MENU_ORDER_STATUS.arriving ||
          this.props.orderTracker.orderObj.orderStatus ===
            MENU_ORDER_STATUS.arrived) &&
        this.props.orderTracker.driver
      ) {
        return this.props.orderTracker.driverRunOrder &&
          this.props.orderTracker.driverRunOrder.arrivingToDestinationTime
          ? this.props.orderTracker.driverRunOrder.arrivingToDestinationTime
          : 'N/A';
      } else if (
        this.props.orderTracker.orderObj.orderStatus ===
          MENU_ORDER_STATUS.delivered &&
        this.props.orderTracker.orderHistory
      ) {
        let finalTime = this.props.orderTracker.orderHistory.filter((d) => {
          return d.orderStatus === MENU_ORDER_STATUS.delivered;
        });
        if (finalTime && finalTime?.length > 0) {
          return `${moment(finalTime[0].date, `YYYY-MM-DD HH:mm`).format(
            'Do MMM, hh:mm A'
          )}`;
        }
        return '';
      } else if (
        this.props.orderTracker.orderObj.orderStatus ===
          MENU_ORDER_STATUS.cancelled &&
        this.props.orderTracker.orderHistory
      ) {
        let finalTime = this.props.orderTracker.orderHistory.filter((d) => {
          return d.orderStatus === MENU_ORDER_STATUS.cancelled;
        });
        if (finalTime && finalTime?.length > 0) {
          return `${moment(finalTime[0].date, `YYYY-MM-DD HH:mm`).format(
            'Do MMM, hh:mm A'
          )}`;
        }
        return '';
      }
    }
  };

  getLinelength = () => {
    let percentage = 0;
    if (
      this.props.orderTracker.store &&
      this.props.orderTracker.store.addressLocation &&
      this.props.orderTracker.orderObj &&
      this.props.orderTracker.orderObj.orderType === MENU_ORDER_TYPE.delivery &&
      (this.props.orderTracker.orderObj.orderStatus ===
        MENU_ORDER_STATUS.on_the_way ||
        this.props.orderTracker.orderObj.orderStatus ===
          MENU_ORDER_STATUS.arriving ||
        this.props.orderTracker.orderObj.orderStatus ===
          MENU_ORDER_STATUS.arrived) &&
      this.props.orderTracker.orderObj.addressLocation &&
      this.props.orderTracker.driver &&
      this.props.orderTracker.driver.currentLocation
    ) {
      var l1 = new window.google.maps.LatLng(
        Number(this.props.orderTracker.store.addressLocation.lat),
        Number(this.props.orderTracker.store.addressLocation.long)
      );
      var l2 = new window.google.maps.LatLng(
        Number(this.props.orderTracker.orderObj.addressLocation.lat),
        Number(this.props.orderTracker.orderObj.addressLocation.lng)
      );
      var l3 = new window.google.maps.LatLng(
        Number(this.props.orderTracker.driver.currentLocation.lat),
        Number(this.props.orderTracker.driver.currentLocation.long)
      );
      // Distance between store and driver
      let distanceBetweenStoreAndDriver =
        window.google.maps.geometry.spherical.computeDistanceBetween(l1, l3);
      // Distance between driver and delivery address
      let distanceBetweenDriverAndDelivery =
        window.google.maps.geometry.spherical.computeDistanceBetween(l3, l2);

      let totalDistance =
        distanceBetweenStoreAndDriver + distanceBetweenDriverAndDelivery;

      let remaingAddress = parseInt(
        100 - (distanceBetweenDriverAndDelivery / totalDistance) * 100,
        10
      );

      return remaingAddress;
    } else if (
      this.props.orderTracker.orderObj &&
      this.props.orderTracker.orderObj.orderType === MENU_ORDER_TYPE.delivery &&
      this.props.orderTracker.orderObj.orderStatus ===
        MENU_ORDER_STATUS.delivered
    ) {
      percentage = 100;
      return percentage;
    } else {
      return percentage;
    }
  };

  getItemCustomizedPrice = (itemObj, sizeObj) => {
    const { halfHalfSetup } = this.props;
    let itemPrice = 0;
    let quantity = 0;
    let halfQuantity = 0;
    let extraPrice = 0;
    let extraPriceHalf = 0;
    let currentItem = JSON.parse(JSON.stringify(itemObj));
    if (!currentItem.itemType || currentItem.itemType === 0) {
      currentItem.selectedSizes &&
        currentItem.selectedSizes.map((item) => {
          if (item._id === sizeObj._id) {
            if (item.quantity > 0) {
              quantity = quantity + item.quantity;
              itemPrice = itemPrice + item.quantity * Number(item.price);
            }
            if (item.variants) {
              item.variants.map((v) => {
                if (v.quantity && Number(v.quantity) > 0)
                  itemPrice = itemPrice + item.quantity * Number(v.price);
                return v;
              });
            }
          }
          return item;
        });
      if (quantity > 0) {
        currentItem.selectedExtraIngredients &&
          currentItem.selectedExtraIngredients.map((item, index) => {
            if (item.quantity > 0) {
              extraPrice =
                extraPrice + Number(item.quantity) * Number(item.price);
            }
            return item;
          });
        itemPrice =
          extraPrice *
            (halfHalfSetup?.chargeFullHalfExtraPrice
              ? Math.max(quantity, 1)
              : quantity) +
          itemPrice;
      }
    } else {
      currentItem.selectedModifiers &&
        currentItem.selectedModifiers.forEach((m) => {
          m.subModifiers.forEach((s) => {
            if (m._id === currentItem.baseModifierId) {
              quantity = s.quantity;
              itemPrice = itemPrice + Number(s.quantity) * Number(s.price);
              if (s.variants) {
                s.variants.forEach((v) => {
                  itemPrice = itemPrice + Number(v.quantity) * Number(v.price);
                });
              }
            } else {
              if (s.prices) {
                s.prices.forEach((p) => {
                  itemPrice = itemPrice + Number(p.quantity) * Number(p.price);
                  if (p.variants) {
                    p.variants.forEach((v) => {
                      itemPrice =
                        itemPrice + Number(v.quantity) * Number(v.price);
                    });
                  }
                });
              }
            }
          });
        });
      if (quantity > 0) {
        currentItem.selectedExtraIngredients &&
          currentItem.selectedExtraIngredients.map((item) => {
            if (item.quantity > 0) {
              extraPrice =
                extraPrice + Number(item.quantity) * Number(item.price);
            }
            return item;
          });
        itemPrice =
          extraPrice *
            (halfHalfSetup?.chargeFullHalfExtraPrice
              ? Math.max(quantity, 1)
              : quantity) +
          itemPrice;
      }
    }
    if (
      currentItem.isHalf &&
      (!currentItem.itemTypeHalf || currentItem.itemTypeHalf === 0)
    ) {
      currentItem.selectedSizesHalf &&
        currentItem.selectedSizesHalf.map((item) => {
          if (item.quantity > 0) {
            halfQuantity = halfQuantity + item.quantity;
            itemPrice = itemPrice + item.quantity * Number(item.price);
          }
          if (item.variants) {
            item.variants.map((v) => {
              if (v.quantity && Number(v.quantity) > 0)
                itemPrice = itemPrice + item.quantity * Number(v.price);
              return v;
            });
          }
          return item;
        });
      if (halfQuantity > 0) {
        currentItem.selectedExtraIngredientsHalf &&
          currentItem.selectedExtraIngredientsHalf.map((item) => {
            if (item.quantity > 0) {
              extraPriceHalf = extraPriceHalf + item.quantity * item.price;
            }
            return item;
          });
        itemPrice = extraPriceHalf * halfQuantity + itemPrice;
      }
    } else if (currentItem.isHalf && currentItem.itemTypeHalf === 1) {
      currentItem.selectedModifiersHalf &&
        currentItem.selectedModifiersHalf.forEach((m) => {
          m.subModifiers.forEach((s) => {
            if (m._id === currentItem.baseModifierIdHalf) {
              halfQuantity = s.quantity;
              itemPrice = itemPrice + Number(s.quantity) * Number(s.price);
              if (s.variants) {
                s.variants.forEach((v) => {
                  itemPrice = itemPrice + Number(v.quantity) * Number(v.price);
                });
              }
            } else {
              if (s.prices) {
                s.prices.forEach((p) => {
                  itemPrice = itemPrice + Number(p.quantity) * Number(p.price);
                  if (p.variants) {
                    p.variants.forEach((v) => {
                      itemPrice =
                        itemPrice + Number(v.quantity) * Number(v.price);
                    });
                  }
                });
              }
            }
          });
        });
      if (halfQuantity > 0) {
        currentItem.selectedExtraIngredientsHalf &&
          currentItem.selectedExtraIngredientsHalf.map((item) => {
            if (item.quantity > 0) {
              extraPriceHalf = extraPriceHalf + item.quantity * item.price;
            }
            return item;
          });
        itemPrice = extraPriceHalf * halfQuantity + itemPrice;
      }
    }
    if (currentItem.isHalf)
      itemPrice =
        itemPrice +
        (this.props.orderTracker.halfHalfSetup &&
        this.props.orderTracker.halfHalfSetup.halfHalfAdditionalCharges
          ? Number(
              this.props.orderTracker.halfHalfSetup.halfHalfAdditionalCharges
            )
          : 0) *
          (quantity + halfQuantity);
    return itemPrice.toFixed(2);
  };

  getTimeToDisplay = () => {
    const { storeConfig } = this.props;
    let today = moment(
      moment().tz(storeConfig.timeZone).format('YYYY-MM-DD HH:mm'),
      'YYYY-MM-DD HH:mm'
    );
    if (
      this.props.orderTracker &&
      this.props.orderTracker.orderObj &&
      this.props.orderTracker.orderObj.deliveryDate
    ) {
      let delDate = moment(
        this.props.orderTracker.orderObj.deliveryDate,
        'YYYY-MM-DD HH:mm'
      );
      if (delDate.isSame(today, 'day')) {
        return `Today, ${delDate.format('hh:mm A')}`;
      } else if (delDate.isSame(today.add(1, 'day'), 'day')) {
        return `Tomorrow, ${delDate.format('hh:mm A')}`;
      } else return delDate.format('Do MMM, ddd, hh:mm A');
    }
  };

  goHome = () => {
    const { orderTracker } = this.props;

    if (
      orderTracker &&
      orderTracker.orderObj &&
      (orderTracker.orderObj.orderStatus === MENU_ORDER_STATUS.delivered ||
        orderTracker.orderObj.orderStatus === MENU_ORDER_STATUS.cancelled ||
        orderTracker.orderObj.orderStatus === MENU_ORDER_STATUS.placed)
    ) {
      if (window.localStorage) {
        if (localStorage.get('currentOrder')) {
          localStorage.set('currentOrder', idealOrderObj);
        }
        if (localStorage.get('userSelectedVoucherItems')) {
          localStorage.set('userSelectedVoucherItems', JSON.stringify([]));
        }
      }
      this.props.resetOrderHandler();

      if (orderTracker.orderObj.orderType === MENU_ORDER_TYPE.dinein) {
        window.location.href = `/dine-in/table-${orderTracker.orderObj.tableNumber}`;
      } else {
        window.location.href = '/';
      }
    }
  };

  enterViewOrderMode = () => {
    this.setState({
      showAnimation: false,
      viewOrderMode: true,
    });
  };

  exitViewMode = () => {
    this.setState(
      {
        showAnimation: true,
      },
      () => {
        setTimeout(() => {
          this.setState({
            viewOrderMode: false,
          });
        }, 300);
      }
    );
  };

  openNotes = () => {
    this.setState({ addNotes: true });
  };

  closeNotes = () => {
    this.setState({ addNotes: false });
  };

  renderViewOrder = (menuItems) => {
    const { storeConfig, orderTracker } = this.props;
    const { cardChargesTitle, cardCharges } = getPlatformAndCardCharges(
      orderTracker?.orderObj
    );

    let viewOrderClass = classNames({
      'aboutWrap true about-animation': this.state.viewOrderMode,
      orderViewTracking: true,
      'about-close-animation': this.state.showAnimation,
    });

    let timeClass = classNames({
      'comM timeRM': true,
      width100: !(
        this.props.orderTracker &&
        this.props.orderTracker.orderObj &&
        this.props.orderTracker.orderObj.notes &&
        this.props.orderTracker.orderObj.notes?.length > 0
      ),
    });

    return (
      <div className={viewOrderClass}>
        <div className='fixedDiv'>
          <BackButtonCWUI
            extendedClassName='absolute top-3.25 left-5 sm:top-3.5'
            onClick={this.exitViewMode}
          />
          <div className='detailsTitle' style={{ marginTop: 0 }}>
            {'Order Details'}
          </div>
          {this.props.orderTracker.orderObj &&
            this.props.orderTracker.orderObj.orderType ===
              MENU_ORDER_TYPE.delivery && (
              <div
                className={
                  this.state.focused
                    ? 'visible-xs visible-sm addressMobileBar foucusedT'
                    : 'visible-xs visible-sm addressMobileBar'
                }
              >
                <div className='addB1'>
                  <i className='icon-Location-Pin' />
                  {this.props.orderTracker.orderObj.address}
                </div>
                <div className='addB2'>
                  <i className='icon-Home' />
                  <input
                    type='text'
                    maxLength='140'
                    className='text-base'
                    ref='flatRef'
                    name='flat'
                    placeholder='Unit / Apartment / Suite Number'
                    value={this.props.orderTracker.orderObj.unit}
                    disabled={true}
                  />
                </div>
              </div>
            )}
          {this.props.orderTracker.orderObj &&
            this.props.orderTracker.orderObj.orderType ===
              MENU_ORDER_TYPE.pickup && (
              <div className='visible-xs visible-sm addressMobileBar'>
                <div className='addB1'>
                  <i className='icon-Store2' />
                  {storeConfig.name}
                </div>
                <div className='addB2 pick'>
                  <i className='icon-Location-Pin' />
                  {storeConfig.address}
                </div>
              </div>
            )}
          <div
            className={
              this.state.voucherState === 'match'
                ? 'reviewOrderWrap match'
                : 'reviewOrderWrap'
            }
          >
            {this.props.orderTracker &&
              this.props.orderTracker.orderObj &&
              this.props.orderTracker.orderObj.menuItems &&
              menuItems.map((item, index) => (
                <div key={index}>
                  {!item.isHalf &&
                    item.selectedSizes.map((size, index) => (
                      <div className='reviewItemO' key={index}>
                        <div className='revieLeft text-capitalize'>
                          {`${size.quantity} ${
                            !item.itemType || item.itemType === 0
                              ? `${size.name} ${item.name}`
                              : `${size.name}${
                                  size.cName && size.cName?.length > 0
                                    ? `,${size.cName}`
                                    : ''
                                } ${item.name}`
                          } 
                          ${
                            size.variants
                              ? size.variants.filter((f) => f.quantity > 0)
                                  ?.length > 0
                                ? `(${size.variants
                                    .filter((f) => f.quantity > 0)
                                    .map((v) => v.name)
                                    .join(',')})`
                                : ''
                              : ''
                          } `}
                          {item.selectedExtraIngredients &&
                            item.selectedExtraIngredients.map(
                              (ingredient, i) => (
                                <span key={i}>{`Extra ${
                                  ingredient.name
                                    ? ingredient.name
                                    : ingredient.ingredientName
                                }`}</span>
                              )
                            )}
                          {item.removedIngredients &&
                            item.removedIngredients.map((ingredient, i) => (
                              <span key={i}>{`Remove ${
                                ingredient.name
                                  ? ingredient.name
                                  : ingredient.ingredientName
                              }`}</span>
                            ))}
                        </div>
                        <div className='revieRight'>{`${
                          storeConfig.currency
                        }${this.getItemCustomizedPrice(item, size)}`}</div>
                      </div>
                    ))}
                  {item.isHalf &&
                    item.selectedSizes.map((size, index) => (
                      <div key={index} className='reviewItemO'>
                        <div className='revieLeft text-capitalize'>
                          {`${size.quantity * 2} 
                          ${
                            !item.itemType || item.itemType === 0
                              ? `${size.name}`
                              : `${size.name} ${
                                  size.cName && size.cName?.length > 0
                                    ? `,${size.cName}`
                                    : ''
                                }`
                          }
                          /
                          ${
                            !item.itemTypeHalf || item.itemTypeHalf === 0
                              ? `${item.selectedSizesHalf
                                  .filter((s) => Number(s.quantity) > 0)
                                  .map((m) => m.name)
                                  .join(' ')}`
                              : `${item.selectedSizesHalf
                                  .filter((s) => Number(s.quantity) > 0)
                                  .map((m) => m.name)
                                  .join(' ')} ${item.selectedSizesHalf
                                  .filter((s) => Number(s.quantity) > 0)
                                  .map((m) => m.cName)
                                  .join(' ')}`
                          } 
                          ${item.name}/${item.nameHalf} 
                          ${
                            size.variants
                              ? size.variants.filter((f) => f.quantity > 0)
                                  ?.length > 0
                                ? `(${size.variants
                                    .filter((f) => f.quantity > 0)
                                    .map((v) => v.name)
                                    .join(',')})`
                                : ''
                              : ''
                          } `}
                          <div>
                            {((item.selectedExtraIngredients &&
                              item.selectedExtraIngredients?.length > 0) ||
                              (item.removedIngredients &&
                                item.removedIngredients?.length > 0)) && (
                              <span className='halfItem'>{item.name}</span>
                            )}
                            {item.selectedExtraIngredients &&
                              item.selectedExtraIngredients.map(
                                (ingredient, i) => (
                                  <span key={i}>{`Extra ${
                                    ingredient.name
                                      ? ingredient.name
                                      : ingredient.ingredientName
                                  }`}</span>
                                )
                              )}
                            {item.removedIngredients &&
                              item.removedIngredients.map((ingredient, i) => (
                                <span key={i}>{`Remove ${
                                  ingredient.name
                                    ? ingredient.name
                                    : ingredient.ingredientName
                                }`}</span>
                              ))}
                          </div>
                          <div className='halfItem'>
                            {((item.selectedExtraIngredientsHalf &&
                              item.selectedExtraIngredientsHalf?.length > 0) ||
                              (item.removedIngredientsHalf &&
                                item.removedIngredientsHalf?.length > 0)) && (
                              <span>{item.nameHalf}</span>
                            )}
                            {item.selectedExtraIngredientsHalf &&
                              item.selectedExtraIngredientsHalf.map(
                                (ingredient, i) => (
                                  <span key={i}>{`Extra ${
                                    ingredient.name
                                      ? ingredient.name
                                      : ingredient.ingredientName
                                  }`}</span>
                                )
                              )}
                            {item.removedIngredientsHalf &&
                              item.removedIngredientsHalf.map(
                                (ingredient, i) => (
                                  <span key={i}>{`Remove ${
                                    ingredient.name
                                      ? ingredient.name
                                      : ingredient.ingredientName
                                  }`}</span>
                                )
                              )}
                          </div>
                        </div>
                        <div className='revieRight'>{`${
                          storeConfig.currency
                        }${this.getItemCustomizedPrice(item, size)}`}</div>
                      </div>
                    ))}
                </div>
              ))}
            {this.props.orderTracker &&
            this.props.orderTracker.orderObj &&
            this.props.orderTracker.orderObj.publicHolidaySurcharge &&
            Number(this.props.orderTracker.orderObj.publicHolidaySurcharge) !==
              0 ? (
              <div className='reviewItemO'>
                <div className='revieLeft text-capitalize'>
                  Public Holiday Surcharge
                  {`${
                    this.props.orderTracker.orderObj &&
                    this.props.orderTracker.orderObj
                      .publicHolidaySurchargePer &&
                    Number(
                      this.props.orderTracker.orderObj.publicHolidaySurchargePer
                    ) !== 0
                      ? `(${this.props.orderTracker.orderObj.publicHolidaySurchargePer}%)`
                      : null
                  }`}
                </div>
                <div className='revieRight'>{` ${storeConfig.currency}${this.props.orderTracker.orderObj.publicHolidaySurcharge}`}</div>
              </div>
            ) : (
              <div />
            )}
            {this.props.orderTracker &&
              this.props.orderTracker.orderObj &&
              this.props.orderTracker.orderObj.rewards &&
              this.props.orderTracker.orderObj.rewards?.length > 0 && (
                <div className='reviewItemO'>
                  <div className='revieLeft text-capitalize'>Loyalty</div>
                  <div className='revieRight'>{`- ${storeConfig.currency}${this.props.orderTracker.orderObj.loyaltyDiscount}`}</div>
                </div>
              )}
            {this.props.orderTracker &&
              this.props.orderTracker.orderObj &&
              this.props.orderTracker.orderObj.specials &&
              this.props.orderTracker.orderObj.specials?.length > 0 && (
                <div className='reviewItemO visible-xs visible-sm'>
                  <div className='revieLeft text-capitalize'>Specials</div>
                  <div className='revieRight'>{`- ${storeConfig.currency}${this.props.orderTracker.orderObj.specialDiscount}`}</div>
                </div>
              )}
            {this.props.orderTracker &&
              this.props.orderTracker.orderObj &&
              this.props.orderTracker.orderObj.voucherId &&
              this.props.orderTracker.orderObj.voucherId !== '' &&
              Number(this.props.orderTracker.orderObj.voucherDiscount) !==
                0 && (
                <div className='reviewItemO visible-xs visible-sm'>
                  <div className='revieLeft text-capitalize'>
                    {this.props.orderTracker.orderObj.selectedVoucher
                      .isLoyaltyVoucher
                      ? 'Reward'
                      : 'Voucher'}
                  </div>
                  <div className='revieRight'>{`- ${storeConfig.currency}${this.props.orderTracker.orderObj.voucherDiscount} `}</div>
                </div>
              )}
            {this.props.orderTracker &&
              this.props.orderTracker.orderObj &&
              this.props.orderTracker.orderObj.isDisplayGST &&
              !this.props.orderTracker.orderObj.isPriceIncludesGST &&
              Number(this.props.orderTracker.orderObj.gst) !== 0 && (
                <div className='reviewItemO visible-xs visible-sm'>
                  <div className='revieLeft'>GST</div>
                  <div className='revieRight'>{` ${storeConfig.currency}${this.props.orderTracker.orderObj.gst} `}</div>
                </div>
              )}
            {cardCharges && (
              <div className='reviewItemO visible-xs visible-sm'>
                <div className='revieLeft'>{cardChargesTitle}</div>
                <div className='revieRight'>{` ${storeConfig.currency}${cardCharges} `}</div>
              </div>
            )}
            {this.props.orderTracker &&
              this.props.orderTracker.orderObj &&
              this.props.orderTracker.orderObj.address &&
              this.props.orderTracker.orderObj.deliveryCost &&
              this.props.orderTracker.orderObj.deliveryCost > 0 && (
                <div className='reviewItemO visible-xs visible-sm'>
                  <div className='revieLeft'>Delivery Fee</div>
                  <div className='revieRight'>{`${storeConfig.currency}${Number(
                    this.props.orderTracker.orderObj.deliveryCost
                  ).toFixed(2)} `}</div>
                </div>
              )}
          </div>
          <div className='visible-xs visible-sm reviewBarM'>
            <React.Fragment>
              {this.props.orderTracker &&
                this.props.orderTracker.orderObj &&
                this.props.orderTracker.orderObj.notes &&
                this.props.orderTracker.orderObj.notes?.length > 0 && (
                  <div
                    className='comM notesM'
                    onClick={
                      this.props.orderTracker &&
                      this.props.orderTracker.orderObj &&
                      this.props.orderTracker.orderObj.notes &&
                      this.props.orderTracker.orderObj.notes?.length > 0
                        ? () => this.openNotes()
                        : () => {}
                    }
                  >
                    <i className='icon-Compose-Document' />
                    {this.props.orderTracker &&
                    this.props.orderTracker.orderObj &&
                    this.props.orderTracker.orderObj.notes &&
                    this.props.orderTracker.orderObj.notes?.length > 0
                      ? `${this.props.orderTracker.orderObj.notes.substring(
                          0,
                          9
                        )}...`
                      : 'Order Notes'}
                  </div>
                )}
              <div className={timeClass}>
                <i className='icon-Clock' />
                {this.getTimeToDisplay()}
              </div>
            </React.Fragment>
          </div>
          <div
            className={
              this.state.addNotes
                ? 'visible-xs visible-sm notesOverlay active'
                : 'visible-xs visible-sm notesOverlay'
            }
          >
            <div
              className='visible-xs visible-sm close-x thickcon-X'
              onClick={() => this.closeNotes()}
            />
            <div className='detailsTitle' style={{ marginTop: 0 }}>
              Notes
            </div>
            <textarea
              ref='addNotes'
              name='addNotes'
              value={
                this.props.orderTracker &&
                this.props.orderTracker.orderObj &&
                this.props.orderTracker.orderObj.notes
                  ? this.props.orderTracker.orderObj.notes
                  : ''
              }
              disabled={true}
            />
          </div>
          <div
            className={
              this.state.timeSlot
                ? 'overlayTime visible-xs visible-sm active'
                : 'overlayTime visible-xs visible-sm'
            }
          />

          <div className='totalInner'>
            {this.props?.orderTracker?.orderObj?.specials?.length > 0 &&
            Number(this.props?.orderTracker?.orderObj?.specialDiscount) > 0 ? (
              <div className='spWrap'>
                <span className='spName'>Specials</span>
                <span className='spPrice'>{`- ${storeConfig.currency}${this.props.orderTracker.orderObj.specialDiscount}`}</span>
              </div>
            ) : (
              <div />
            )}
            {this.props?.orderTracker?.orderObj?.voucherId !== '' &&
            Number(this.props?.orderTracker?.orderObj?.voucherDiscount) !==
              0 ? (
              <div className='spWrap'>
                <span className='spName'>
                  {this.props.orderTracker.orderObj.selectedVoucher
                    .isLoyaltyVoucher
                    ? 'Reward'
                    : 'Voucher'}
                </span>
                <span className='spPrice'>{`- ${storeConfig.currency}${this.props.orderTracker.orderObj.voucherDiscount} `}</span>
              </div>
            ) : (
              <div />
            )}
            {this.props?.orderTracker?.orderObj?.isDisplayGST &&
            !this.props?.orderTracker?.orderObj?.isPriceIncludesGST &&
            Number(this.props?.orderTracker?.orderObj?.gst) !== 0 ? (
              <div className='spWrap'>
                <span className='spName'>GST</span>
                <span className='spPrice'>{` ${storeConfig.currency}${this.props.orderTracker.orderObj.gst} `}</span>
              </div>
            ) : (
              <div />
            )}
            {cardCharges ? (
              <div className='spWrap'>
                <span className='spName'>{cardChargesTitle}</span>
                <span className='spPrice'>{` ${storeConfig.currency}${cardCharges} `}</span>
              </div>
            ) : (
              <div />
            )}
          </div>
        </div>
      </div>
    );
  };

  enterDesktopViewOrderMode = () => {
    this.setState(
      {
        showClosingAnimation: false,
      },
      () => {
        this.setState(
          {
            renderReviewScreen: true,
          },
          () => {
            setTimeout(() => {
              this.setState({
                enterDesktopViewMode: true,
              });
            }, 100);
          }
        );
      }
    );
  };

  exitDesktopViewMode = () => {
    this.setState(
      {
        showClosingAnimation: true,
      },
      () => {
        setTimeout(() => {
          this.setState({
            renderReviewScreen: false,
            enterDesktopViewMode: false,
            showClosingAnimation: false,
          });
        }, 600);
      }
    );
  };

  printPDF = () => {
    const { storeConfig } = this.props;
    var printWindow = window.open('', '_blank');
    if (printWindow) {
      printWindow.document.write(
        template(
          this.props.orderTracker.orderObj,
          storeConfig,
          this.props?.orderTracker?.halfHalfSetup?.halfHalfAdditionalCharges
            ? Number(
                this.props.orderTracker.halfHalfSetup.halfHalfAdditionalCharges
              )
            : 0
        )
      );
      printWindow.document.close();
      printWindow.print();
    } else {
      console.error('Print window is not defined');
    }
  };

  renderDesktopViewOrder = (menuItems) => {
    const { storeConfig, orderTracker } = this.props;
    const { cardChargesTitle, cardCharges } = getPlatformAndCardCharges(
      orderTracker?.orderObj
    );

    let desktopViewContainerClass = classNames({
      desktopViewOrderContainer: true,
      rightSideVisibility: this.state.renderReviewScreen === true,
      showDesktopViewContainer: this.state.enterDesktopViewMode === true,
      showViewClosingAnimation: this.state.showClosingAnimation === true,
    });

    let timeClass = classNames({
      'comM timeRM': true,
      width100: !(
        this.props.orderTracker &&
        this.props.orderTracker.orderObj &&
        this.props.orderTracker.orderObj.notes &&
        this.props.orderTracker.orderObj.notes?.length > 0
      ),
    });

    return (
      <React.Fragment>
        <div className={desktopViewContainerClass}>
          <div className='fixedDiv'>
            <BackButtonCWUI
              extendedClassName='absolute left-5 top-3.5 '
              onClick={this.exitDesktopViewMode}
            />
            <div
              className='detailsTitle'
              style={{ paddingLeft: '2rem', minWidth: '25vw' }}
            >
              {'Order Details'}
            </div>
            {this.props.orderTracker.orderObj &&
              this.props.orderTracker.orderObj.orderType ===
                MENU_ORDER_TYPE.delivery && (
                <div className='addressMobileBar address-booking-bar'>
                  <div className='restaurant-address'>
                    <i className='icon-Store2 zoom-icon' />
                    <div className='align-with-label align-address'>
                      {this.props.orderTracker.orderObj.address}
                    </div>
                  </div>
                  <div className='address-time-bar pick false'>
                    <i className='icon-Location-Pin zoom-icon margin-2-rem' />
                    <div
                      className='align-with-label align-address orderTrackerInput'
                      style={{ width: '100%' }}
                    >
                      <input
                        type='text'
                        maxLength='140'
                        ref='flatRef'
                        name='flat'
                        className='text-base pl-0'
                        placeholder='Unit / Apartment / Suite Number'
                        value={this.props.orderTracker.orderObj.unit}
                        disabled={true}
                        style={{ width: '100%' }}
                      />
                    </div>
                  </div>
                </div>
              )}
            {this.props.orderTracker.orderObj &&
              this.props.orderTracker.orderObj.orderType ===
                MENU_ORDER_TYPE.pickup && (
                <div className='addressMobileBar address-booking-bar'>
                  <div className='restaurant-address'>
                    <i className='icon-Store2 zoom-icon'></i>
                    <div className='align-with-label align-address'>
                      {storeConfig.name}
                    </div>
                  </div>
                  <div className='address-time-bar pick false'>
                    <i className='icon-Location-Pin zoom-icon margin-2-rem'></i>
                    <div
                      className='align-with-label align-address'
                      style={{ cursor: 'pointer' }}
                    >
                      {storeConfig.address}
                    </div>
                  </div>
                </div>
              )}
            <div className={'reviewOrderWrapper'}>
              {this.props?.orderTracker?.orderObj?.menuItems &&
                menuItems.map((item, index) => (
                  <div key={index}>
                    {!item.isHalf &&
                      item.selectedSizes.map((size, index) => (
                        <div className='reviewItemO' key={index}>
                          <div className='revieLeft text-capitalize'>
                            {`${size.quantity} ${
                              !item.itemType || item.itemType === 0
                                ? `${size.name} ${item.name}`
                                : `${size.name}${
                                    size.cName && size.cName?.length > 0
                                      ? `,${size.cName}`
                                      : ''
                                  } ${item.name}`
                            } 
                            ${
                              size.variants
                                ? size.variants.filter((f) => f.quantity > 0)
                                    ?.length > 0
                                  ? `(${size.variants
                                      .filter((f) => f.quantity > 0)
                                      .map((v) => v.name)
                                      .join(',')})`
                                  : ''
                                : ''
                            } `}
                            {item.selectedExtraIngredients &&
                              item.selectedExtraIngredients.map(
                                (ingredient, i) => (
                                  <span key={i}>{`Extra ${
                                    ingredient.name
                                      ? ingredient.name
                                      : ingredient.ingredientName
                                  }`}</span>
                                )
                              )}
                            {item.removedIngredients &&
                              item.removedIngredients.map((ingredient, i) => (
                                <span key={i}>{`Remove ${
                                  ingredient.name
                                    ? ingredient.name
                                    : ingredient.ingredientName
                                }`}</span>
                              ))}
                          </div>
                          <div className='revieRight'>{`${
                            storeConfig.currency
                          }${this.getItemCustomizedPrice(item, size)}`}</div>
                        </div>
                      ))}
                    {item.isHalf &&
                      item.selectedSizes.map((size, index) => (
                        <div key={index} className='reviewItemO'>
                          <div className='revieLeft text-capitalize'>
                            {`${size.quantity * 2} 
                          ${
                            !item.itemType || item.itemType === 0
                              ? `${size.name}`
                              : `${size.name} ${
                                  size.cName && size.cName?.length > 0
                                    ? `,${size.cName}`
                                    : ''
                                }`
                          }
                          /
                          ${
                            !item.itemTypeHalf || item.itemTypeHalf === 0
                              ? `${item.selectedSizesHalf
                                  .filter((s) => Number(s.quantity) > 0)
                                  .map((m) => m.name)
                                  .join(' ')}`
                              : `${item.selectedSizesHalf
                                  .filter((s) => Number(s.quantity) > 0)
                                  .map((m) => m.name)
                                  .join(' ')} ${item.selectedSizesHalf
                                  .filter((s) => Number(s.quantity) > 0)
                                  .map((m) => m.cName)
                                  .join(' ')}`
                          } 
                          ${item.name}/${item.nameHalf} 
                          ${
                            size.variants
                              ? size.variants.filter((f) => f.quantity > 0)
                                  ?.length > 0
                                ? `(${size.variants
                                    .filter((f) => f.quantity > 0)
                                    .map((v) => v.name)
                                    .join(',')})`
                                : ''
                              : ''
                          } `}
                            <div>
                              {((item.selectedExtraIngredients &&
                                item.selectedExtraIngredients?.length > 0) ||
                                (item.removedIngredients &&
                                  item.removedIngredients?.length > 0)) && (
                                <span className='halfItem'>{item.name}</span>
                              )}
                              {item.selectedExtraIngredients &&
                                item.selectedExtraIngredients.map(
                                  (ingredient, i) => (
                                    <span key={i}>{`Extra ${
                                      ingredient.name
                                        ? ingredient.name
                                        : ingredient.ingredientName
                                    }`}</span>
                                  )
                                )}
                              {item.removedIngredients &&
                                item.removedIngredients.map((ingredient, i) => (
                                  <span key={i}>{`Remove ${
                                    ingredient.name
                                      ? ingredient.name
                                      : ingredient.ingredientName
                                  }`}</span>
                                ))}
                            </div>
                            <div className='halfItem'>
                              {((item.selectedExtraIngredientsHalf &&
                                item.selectedExtraIngredientsHalf?.length >
                                  0) ||
                                (item.removedIngredientsHalf &&
                                  item.removedIngredientsHalf?.length > 0)) && (
                                <span>{item.nameHalf}</span>
                              )}
                              {item.selectedExtraIngredientsHalf &&
                                item.selectedExtraIngredientsHalf.map(
                                  (ingredient, i) => (
                                    <span key={i}>{`Extra ${
                                      ingredient.name
                                        ? ingredient.name
                                        : ingredient.ingredientName
                                    }`}</span>
                                  )
                                )}
                              {item.removedIngredientsHalf &&
                                item.removedIngredientsHalf.map(
                                  (ingredient, i) => (
                                    <span key={i}>{`Remove ${
                                      ingredient.name
                                        ? ingredient.name
                                        : ingredient.ingredientName
                                    }`}</span>
                                  )
                                )}
                            </div>
                          </div>
                          <div className='revieRight'>{`${
                            storeConfig.currency
                          }${this.getItemCustomizedPrice(item, size)}`}</div>
                        </div>
                      ))}
                  </div>
                ))}
              {this.props.orderTracker &&
              this.props.orderTracker.orderObj &&
              this.props.orderTracker.orderObj.publicHolidaySurcharge &&
              Number(
                this.props.orderTracker.orderObj.publicHolidaySurcharge
              ) !== 0 ? (
                <div className='reviewItemO'>
                  <div className='revieLeft text-capitalize'>
                    Public Holiday Surcharge
                    {`${
                      this.props.orderTracker.orderObj &&
                      this.props.orderTracker.orderObj
                        .publicHolidaySurchargePer &&
                      Number(
                        this.props.orderTracker.orderObj
                          .publicHolidaySurchargePer
                      ) !== 0
                        ? `(${this.props.orderTracker.orderObj.publicHolidaySurchargePer}%)`
                        : null
                    }`}
                  </div>
                  <div className='revieRight'>{`${storeConfig.currency}${this.props.orderTracker.orderObj.publicHolidaySurcharge}`}</div>
                </div>
              ) : (
                <div />
              )}
              {this.props.orderTracker &&
                this.props.orderTracker.orderObj &&
                this.props.orderTracker.orderObj.rewards &&
                this.props.orderTracker.orderObj.rewards?.length > 0 && (
                  <div className='reviewItemO'>
                    <div className='revieLeft'>Loyalty</div>
                    <div className='revieRight'>{`- ${storeConfig.currency}${this.props.orderTracker.orderObj.loyaltyDiscount}`}</div>
                  </div>
                )}
              {this.props.orderTracker &&
                this.props.orderTracker.orderObj &&
                this.props.orderTracker.orderObj.specials &&
                this.props.orderTracker.orderObj.specials?.length > 0 && (
                  <div className='reviewItemO'>
                    <div className='revieLeft'>Specials</div>
                    <div className='revieRight'>{`- ${storeConfig.currency}${this.props.orderTracker.orderObj.specialDiscount}`}</div>
                  </div>
                )}
              {this.props.orderTracker &&
                this.props.orderTracker.orderObj &&
                this.props.orderTracker.orderObj.voucherId &&
                this.props.orderTracker.orderObj.voucherId !== '' &&
                Number(this.props.orderTracker.orderObj.voucherDiscount) !==
                  0 && (
                  <div className='reviewItemO'>
                    <div className='revieLeft'>
                      {this.props.orderTracker.orderObj.selectedVoucher
                        .isLoyaltyVoucher
                        ? 'Reward'
                        : 'Voucher'}
                    </div>
                    <div className='revieRight'>{`- ${storeConfig.currency}${this.props.orderTracker.orderObj.voucherDiscount} `}</div>
                  </div>
                )}
              {this.props.orderTracker &&
                this.props.orderTracker.orderObj &&
                this.props.orderTracker.orderObj.isDisplayGST &&
                !this.props.orderTracker.orderObj.isPriceIncludesGST &&
                Number(this.props.orderTracker.orderObj.gst) !== 0 && (
                  <div className='reviewItemO'>
                    <div className='revieLeft'>GST</div>
                    <div className='revieRight'>{` ${storeConfig.currency}${this.props.orderTracker.orderObj.gst} `}</div>
                  </div>
                )}
              {cardCharges && (
                <div className='reviewItemO'>
                  <div className='revieLeft'>{cardChargesTitle}</div>
                  <div className='revieRight'>{` ${storeConfig.currency}${cardCharges} `}</div>
                </div>
              )}
              {this.props.orderTracker &&
                this.props.orderTracker.orderObj &&
                this.props.orderTracker.orderObj.address &&
                this.props.orderTracker.orderObj.deliveryCost &&
                this.props.orderTracker.orderObj.deliveryCost > 0 && (
                  <div className='reviewItemO'>
                    <div className='revieLeft'>Delivery Fee</div>
                    <div className='revieRight'>{`${
                      storeConfig.currency
                    }${Number(
                      this.props.orderTracker.orderObj.deliveryCost
                    ).toFixed(2)} `}</div>
                  </div>
                )}
            </div>
            <div className='reviewBarM'>
              <React.Fragment>
                {this.props.orderTracker &&
                  this.props.orderTracker.orderObj &&
                  this.props.orderTracker.orderObj.notes &&
                  this.props.orderTracker.orderObj.notes?.length > 0 && (
                    <div
                      className='comM notesM'
                      onClick={
                        this.props.orderTracker &&
                        this.props.orderTracker.orderObj &&
                        this.props.orderTracker.orderObj.notes &&
                        this.props.orderTracker.orderObj.notes?.length > 0
                          ? () => this.openNotes()
                          : () => {}
                      }
                    >
                      <i className='icon-Compose-Document' />
                      {this.props.orderTracker &&
                      this.props.orderTracker.orderObj &&
                      this.props.orderTracker.orderObj.notes &&
                      this.props.orderTracker.orderObj.notes?.length > 0
                        ? `${this.props.orderTracker.orderObj.notes.substring(
                            0,
                            9
                          )}...`
                        : 'Order Notes'}
                    </div>
                  )}
                <div className={timeClass}>
                  <i className='icon-Clock' />
                  {this.getTimeToDisplay()}
                </div>
              </React.Fragment>
            </div>
            <div
              className={
                this.state.addNotes ? 'notesOverlay active' : 'notesOverlay'
              }
            >
              <div
                className='close-x thickcon-X'
                onClick={() => this.closeNotes()}
              />
              <div className='detailsTitle' style={{ marginTop: 0 }}>
                Notes
              </div>
              <textarea
                ref='addNotes'
                name='addNotes'
                value={
                  this.props.orderTracker &&
                  this.props.orderTracker.orderObj &&
                  this.props.orderTracker.orderObj.notes
                    ? this.props.orderTracker.orderObj.notes
                    : ''
                }
                disabled={true}
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };

  render() {
    const { storeConfig, orderTracker, halfHalfSetup } = this.props;
    const { pathname } = window.location;
    const orderType = pathname?.split('/')[3];

    let mapClass = classNames({
      mapAbs: true,
      desktopViewOrder: this.state.enterDesktopViewMode === true,
      showFullWidth: this.state.showClosingAnimation === true,
    });
    let menuItems =
      orderTracker && orderTracker.orderObj
        ? this.getItemGroupingsForReviewOrder(orderTracker.orderObj)
        : [];

    if (
      orderTracker?.orderObj?.orderType === MENU_ORDER_TYPE.dinein ||
      orderType === MENU_ORDER_TYPE.dinein
    ) {
      const statusText = this.getOrderStatusDisplayText();
      const data = getViewOrderData({
        menuItems,
        currency: storeConfig?.currency,
        halfHalfSetup,
        orderTracker,
      });
      return (
        <DineInOrderTraking
          data={data}
          orderTracker={orderTracker}
          statusText={statusText}
        />
      );
    }

    return (
      <React.Fragment>
        {this.state.viewOrderMode === true && this.renderViewOrder(menuItems)}
        <div style={{ height: 'calc(100vh - 48px)' }}>
          <nav
            ref='nav'
            // TODO: removed all the below classes. Need to redo css
            className='navbar topnav navbar-fixed-top bgwhite compact shadow-cw-layout'
          >
            <div className='container-fluid topnav'>
              <div className='navbar-header'>
                <div className='logoWrap' onClick={() => this.goHome()}>
                  <img
                    src={getImage(storeConfig.logoPath || storeConfig.logo)}
                    alt='logo'
                    className='logo'
                  />
                </div>
              </div>
              {orderTracker.orderObj &&
                (orderTracker.orderObj.orderStatus ===
                  MENU_ORDER_STATUS.delivered ||
                  orderTracker.orderObj.orderStatus ===
                    MENU_ORDER_STATUS.cancelled ||
                  orderTracker.orderObj.orderStatus ===
                    MENU_ORDER_STATUS.placed) &&
                !orderTracker.orderObj.isRedirect && (
                  <div
                    className={
                      window.innerWidth > 992 &&
                      !(
                        window.navigator.userAgent.match(/iPad/i) &&
                        window.innerHeight > 1250
                      )
                        ? 'Home comGo'
                        : 'comGo'
                    }
                    onClick={() => this.goHome()}
                  >
                    {window.innerWidth > 992 &&
                    !(
                      window.navigator.userAgent.match(/iPad/i) &&
                      window.innerHeight > 1250
                    ) ? (
                      'Place another Order'
                    ) : (
                      <>
                        <BackButtonCWUI extendedClassName='absolute -top-3.25 left-1 sm:-top-3 min-[991px]:hidden' />
                      </>
                    )}
                  </div>
                )}
            </div>
          </nav>
          <div className='container-fluid shadowIt'>
            <div className='row'>
              <div
                className='col-xs-12 customWidth noPad'
                style={{ height: '100%', overflow: 'hidden' }}
              >
                <div className='map-items' style={{ height: '100%' }}>
                  <div className={mapClass}>
                    <DriverTracker
                      currentOrder={orderTracker.orderObj}
                      store={orderTracker.store}
                      driver={orderTracker.driver}
                    />
                    {orderTracker.orderObj && (
                      <div className='deliveryWrapFinal active'>
                        <div className='oneDel'>
                          <p>{this.getOrderStatusDisplayText()}</p>
                          <p>
                            <i className='icon-Clock' />
                            {this.getOrderTimeDisplayText()}
                          </p>
                        </div>
                        {orderTracker.orderObj.orderType !==
                          MENU_ORDER_TYPE.dinein && (
                          <div className='twoDel'>
                            <p>
                              <i className='icon-Location-Pin' />
                              {orderTracker.orderObj &&
                              orderTracker.orderObj.orderType ===
                                MENU_ORDER_TYPE.pickup
                                ? orderTracker.store
                                  ? `${orderTracker.store.street},${orderTracker.store.city}`
                                  : 'N/A'
                                : orderTracker.orderObj &&
                                  orderTracker.orderObj.address
                                ? orderTracker.orderObj.unit
                                  ? `${orderTracker.orderObj.unit} / ${orderTracker.orderObj.address}`
                                  : orderTracker.orderObj.address
                                : 'N/A'}
                            </p>
                          </div>
                        )}
                        {window.innerWidth < 991 &&
                          this.props &&
                          orderTracker &&
                          orderTracker.orderObj &&
                          (orderTracker.orderObj.orderType ===
                            MENU_ORDER_TYPE.pickup ||
                            orderTracker.orderObj.orderType ===
                              MENU_ORDER_TYPE.delivery ||
                            orderTracker.orderObj.orderType ===
                              MENU_ORDER_TYPE.dinein) && (
                            <div className='viewOrderContainer'>
                              <button
                                className='viewOrderButton'
                                onClick={() => this.enterViewOrderMode()}
                              >
                                View Order
                              </button>
                              {this.props &&
                                orderTracker &&
                                orderTracker.orderObj &&
                                orderTracker.orderObj.orderStatus !==
                                  MENU_ORDER_STATUS.unconfirmed &&
                                orderTracker.orderObj.orderStatus !==
                                  MENU_ORDER_STATUS.cancelled && (
                                  <button
                                    className='viewOrderButton'
                                    style={{ marginLeft: '2rem' }}
                                    onClick={() => this.printPDF()}
                                  >
                                    View PDF
                                  </button>
                                )}
                            </div>
                          )}
                        {window.innerWidth > 991 &&
                          this.props &&
                          orderTracker &&
                          orderTracker.orderObj &&
                          (orderTracker.orderObj.orderType ===
                            MENU_ORDER_TYPE.pickup ||
                            orderTracker.orderObj.orderType ===
                              MENU_ORDER_TYPE.delivery ||
                            orderTracker.orderObj.orderType ===
                              MENU_ORDER_TYPE.dinein) && (
                            <div className='viewOrderContainer'>
                              <button
                                className='viewOrderButton'
                                onClick={() => this.enterDesktopViewOrderMode()}
                              >
                                View Order
                              </button>
                              {this.props &&
                                orderTracker &&
                                orderTracker.orderObj &&
                                orderTracker.orderObj.orderStatus !==
                                  MENU_ORDER_STATUS.unconfirmed &&
                                orderTracker.orderObj.orderStatus !==
                                  MENU_ORDER_STATUS.cancelled && (
                                  <button
                                    className='viewOrderButton'
                                    style={{ marginLeft: '2rem' }}
                                    onClick={() => this.printPDF()}
                                  >
                                    View PDF
                                  </button>
                                )}
                            </div>
                          )}
                        <div className='threeDel hide'>
                          <span>Contact Store</span>
                          <span>View Order</span>
                        </div>
                        {orderTracker.orderObj &&
                          orderTracker.orderObj.orderType ===
                            MENU_ORDER_TYPE.pickup && (
                            <div className='progressIcons'>
                              <div
                                className={
                                  orderTracker.orderObj &&
                                  orderTracker.orderObj.orderStatus ===
                                    MENU_ORDER_STATUS.placed
                                    ? 'store pickup active'
                                    : 'pickup store'
                                }
                              >
                                <i className='icon-Store2' />
                              </div>
                            </div>
                          )}
                        {orderTracker.orderObj &&
                          orderTracker.orderObj.orderType ===
                            MENU_ORDER_TYPE.delivery && (
                            <div className='progressIcons'>
                              <div
                                className={
                                  orderTracker.orderObj &&
                                  orderTracker.orderObj.orderStatus ===
                                    MENU_ORDER_STATUS.in_kitchen
                                    ? `store active del${orderTracker.orderObj.orderStatus}`
                                    : `store del${orderTracker.orderObj.orderStatus}`
                                }
                              >
                                <i className='icon-Store2' />
                              </div>
                              <div
                                className={
                                  orderTracker.orderObj &&
                                  (orderTracker.orderObj.orderStatus ===
                                    MENU_ORDER_STATUS.on_the_way ||
                                    orderTracker.orderObj.orderStatus ===
                                      '12' ||
                                    orderTracker.orderObj.orderStatus ===
                                      '13' ||
                                    orderTracker.orderObj.orderStatus ===
                                      MENU_ORDER_STATUS.delivered)
                                    ? 'moped active'
                                    : 'moped'
                                }
                              >
                                <i className='icon-Moped' />
                              </div>
                              <span
                                className={
                                  orderTracker.orderObj &&
                                  (orderTracker.orderObj.orderStatus ===
                                    MENU_ORDER_STATUS.on_the_way ||
                                    orderTracker.orderObj.orderStatus ===
                                      '12' ||
                                    orderTracker.orderObj.orderStatus ===
                                      '13' ||
                                    orderTracker.orderObj.orderStatus ===
                                      MENU_ORDER_STATUS.delivered)
                                    ? 'progressbar active'
                                    : 'progressbar'
                                }
                              >
                                <i
                                  style={{ width: `${this.getLinelength()}%` }}
                                />
                              </span>
                              {orderTracker.orderObj &&
                              orderTracker.orderObj.orderStatus ===
                                MENU_ORDER_STATUS.delivered ? (
                                <div className='delivered active'>
                                  <i className='delivery icon-Delivery'>
                                    <img src={deliveryWhite} alt='' />
                                  </i>
                                </div>
                              ) : (
                                <div className='delivered'>
                                  <i className='delivery icon-Delivery'>
                                    <Delivery className='delivery-svg' />
                                  </i>
                                </div>
                              )}
                            </div>
                          )}
                        <div className='re-center hide'>
                          <i className='icon-Location-Arrow' />
                        </div>
                      </div>
                    )}
                  </div>
                  {this.props &&
                    orderTracker &&
                    orderTracker.orderObj &&
                    this.renderDesktopViewOrder(menuItems)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    orderTracker: state.orderTrackerReducer,
    storeConfig: selectStoreConfig(state),
    halfHalfSetup: state.layoutReducer.halfHalfSetup,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchCurrentOrderHandler: (key, orderType) =>
      dispatch(fetchCurrentOrder(key, orderType)),
    fetchDriverOnTheWayHandler: (key, storeId) =>
      dispatch(fetchDriverOnTheWay(key, storeId)),
    fetchOrderStatusHistoryHandler: (key, orderType, storeId) =>
      dispatch(fetchOrderStatusHistory(key, orderType, storeId)),
    fetchDriverRunOrderHandler: (key, storeId) =>
      dispatch(fetchDriverRunOrder(key, storeId)),
    resetOrderHandler: () => dispatch(resetCurrentOrder()),
    getAllShiftsHandler: (storeId) => dispatch(getAllShifts(storeId)),
    getHalfHalfHandler: (storeId) => dispatch(getHalfHalf(storeId)),
    getStoreInfoHandler: (storeId) => dispatch(getStoreInfo(storeId)),
    fetchOrderHandler: (key) => dispatch(fetchOrder(key)),
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(OrderTracker)
);
